export const stringConstants = {
  buttonClick: '- Button is clicked ',
  clipboard: '- clipboard',
  close: 'Close Button is clicked ',
  done: ' - Done Button is clicked  ',
  valueChange: ' value is  ',
  onExpire: ' clicked on Expire button ',
  for: 'for',
  dash: ' - ',
  edit: ' - Edit Button is clicked ',
  addIcon: '- Add Icon is clicked',
  cancel: ' - Cancel Button is clicked ',
  next: ' - Next Button is clicked ',
  downloadButton: ' - Download Button is clicked',
  toggleClick: '- Toggle button is clicked ',
  downloadIcon: ' - Download Icon button is clicked',
  apportionClick: ' - Apportion toggle icon is clicked',
  hideFloorClick: ' - Hide Floor button is clicked',
  moveFloorClick: ' - Move Floor button is clicked',
  showFilter: '- Show Filter button is clicked',
  hideFilter: '- Hide Filter button is clicked',
  addFilter: '- Add Filters button is clicked',
  resetFilter: '- Reset Filters button is clicked',
  addProperty: '- add property is clicked',
  settingClick: '- Setting icon button is clicked',
  propertyHistoricalStats: ' - selected property historicalStats button',
  property: ' - selected property button',
  clearValues: '- Clear Filters button is clicked',
  saveSearch: '- Save Search button is clicked',
  viewsavedSearch: '- View Saved Search button is clicked',
  tableView: '- selected Table View ',
  bothView: ' -selected Table and Map View',
  mapView: '- selected Map View',
  details: '- Table row details is clicked.',
  valueChanged: ' - value has changed for ',
  searchClicked: '- search Icon is clicked',
  searchCancel: '- Cancel button is clicked for Search',
  closeIcon: '- Close icon is clicked for ',
  pageClicked: '- page is clicked.',
  howToVideos: ' Home page - howToVideos is clicked.',
  isClicked: 'is clicked .',
  save: ' Save button is clicked ',
  profile: ' User clicked on Myprofile .',
  logOut: 'User clicked on logout .',
  lang: 'User clicked on Language. ',
  addButton: '- Add Button is clicked ',
  deleteButton: '- Delete Button is clicked ',
  changeProperty: '- Change Property Type is clicked .',
  moveToAnotherProperty: 'Move to another Property Type is clicked',
  isClickedFor: ' - button is clicked for ',
  selectComplex: '- Select complex button is clicked .',
  editComplex: ' -Edit complex button is Clicked',
  backButton: 'Back button is clicked .',
  closeButtonForAddProperty: ' Close button is clicked Add Property type .',
  submitButtonForAddProperty: ' Add Button is clicked for Add Property Type .',
  cancelDownload: ' - Close Button is clicked for Download As Excel .',
  download: ' - Download Button is clicked for Download As Excel .',
  continueAddProperty: 'Continue Button is clicked for Add Property .',
  cancelAddProperty: 'Cancel Button is clicked for Add Property .',
  reset: 'Reset Button is clicked',
  backButtonFor: ' - Back Button is clicked for ',
  cancelClick: 'Cancel button is clicked for ',
  resetFor: ' Reset button is clicked for ',
  saveAddFilter: ' Save button is clicked for Add Filters for ',
  clearAll: ' - Clear all Button is clicked .',
  createReport: ' - Create Report button is clicked .',
  downloadHistorical: ' - Download Historical button is clicked',
  labelUpdate: '- Label Update button is clicked .',
  mergeRequest: ' - Merge Request button is clicked .',
  submitMergeRequest: 'Submit button is clicked for Request Merge',
  cancelMergeRequest: 'Close button is clicked for Request Merge',
  tabClick: ' - Tab is clicked .',
  cancelCreateReport: ' canceled create report .',
  saveCreateReport: ' Save Button is clicked for Create Report .',
  viewSavedSearch: '- Close Button is clicked for View Saved Search',
  cancelButtonForUpdateLabel: ' Close Button is clicked for Label Update .',
  doneButtonForLabelUpdate: ' Done Button is clicked for Label Update',
  deleteOPtion: '- Deleted option in ',
  selectRow: ' - Selected table row',
  CancelSelectRow: ' -  Cancel selected table row',
  selectRadio: ' - Selected radio button .',
  check: ' - Selected checkbox  ',
  unCheck: ' - Unselected checkbox  ',
  all: 'all',
  enableToggle: ' - enabled the toggle for ',
  diableToggle: ' - disabled the toggle for',
  searchResult: ' - search result for ',
  searchAddressDropdown: ' Search Address drop down .',
  stackingPlan: 'Property - Stacking Plan',
  refreshClick: '- Refresh icon button is clicked',
  addClick: '- Add icon button is clicked',
  buildingInfoClick: '- Building Info icon button is clicked',
};
